import React from "react";

const EmailPreview = () => {
  const sampleData = {
    owner1FirstName: "John",
    businessLegalName: "ABC Construction LLC",
  };

  return (
    <div className="py-12 px-4">
      <div className="max-w-2xl mx-auto">
        <div style={{ fontFamily: "Arial, sans-serif", maxWidth: "600px" }}>
          <div
            style={{
              background: "#2563eb",
              padding: "30px",
              borderRadius: "8px 8px 0 0",
            }}
          >
            <h1
              style={{
                color: "white",
                margin: 0,
                fontSize: "24px",
                fontWeight: "bold",
              }}
            >
              Lloyd Funding
            </h1>
          </div>
          <div
            style={{
              padding: "30px",
              border: "1px solid #e2e8f0",
              borderTop: "none",
              borderRadius: "0 0 8px 8px",
            }}
          >
            <h2 style={{ color: "#1e3a5f", marginTop: 0 }}>
              Thank You, {sampleData.owner1FirstName}!
            </h2>
            <p style={{ color: "#475569", lineHeight: 1.6 }}>
              We've received your funding application for{" "}
              <strong>{sampleData.businessLegalName}</strong>. Our team will
              review your information and reach out within 24 hours.
            </p>
            <div
              style={{
                background: "#f1f5f9",
                padding: "20px",
                borderRadius: "8px",
                margin: "20px 0",
              }}
            >
              <p
                style={{
                  margin: "0 0 12px",
                  color: "#64748b",
                  fontSize: "14px",
                }}
              >
                What happens next:
              </p>
              <div style={{ color: "#475569", lineHeight: 1.8 }}>
                <p style={{ margin: "0 0 8px" }}>
                  <strong>1.</strong> Our team reviews your application
                </p>
                <p style={{ margin: "0 0 8px" }}>
                  <strong>2.</strong> We match you with the best funding options
                </p>
                <p style={{ margin: 0 }}>
                  <strong>3.</strong> A funding specialist will contact you to
                  discuss your options
                </p>
              </div>
            </div>
            <p style={{ color: "#475569", lineHeight: 1.6 }}>
              If you have any questions in the meantime, feel free to contact us
              at{" "}
              <a
                href="mailto:submissions@lloydfunding.com"
                style={{ color: "#2563eb" }}
              >
                submissions@lloydfunding.com
              </a>
              .
            </p>
            <p style={{ color: "#475569", marginBottom: 0 }}>
              Best regards,
              <br />
              <strong>The Lloyd Funding Team</strong>
            </p>
          </div>
          <p
            style={{
              color: "#94a3b8",
              fontSize: "12px",
              textAlign: "center",
              marginTop: "20px",
            }}
          >
            Lloyd Funding Group Inc dba Lloyd Funding
            <br />
            This is an automated confirmation email.
          </p>
        </div>
      </div>
    </div>
  );
};

export default EmailPreview;
